module.exports = __webpack_public_path__ + "static/media/pkar_logo.6ed9477a.png";